import styled from '@emotion/styled'
import { Chip } from 'ui-components/Chip'

export const FormContainer = styled.form`
  display: grid;
  grid-template-columns: auto 45px;
`

export const Filters = styled.div`
  max-width: 92%;
`

export const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
`

export const SortOptions = styled.div`
  font-size: 12px;

  & > span {
    margin-right: 10px;
  }
`

export const SortOption = styled(Chip)`
  margin: 0 5px;
`
